<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card v-if="isShow" :class="classContents">
      <v-card-title>
        <h3>{{ modeTitle }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.type') }}</span>
              </div>
              <div class="float-left column-contents-w">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="copyFormData.programType" :items="programType" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.programName') }}</span>
              </div>
              <div class="float-left column-contents-w">
                <v-text-field v-model="copyFormData.programName" :error-messages="errorMessages" class="w-auto" @blur="validPgNameRule()" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="12">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.description') }}</span>
              </div>
              <div class="float-left column-contents-w chk-min-con">
                <v-text-field v-model="copyFormData.programText" class="w-auto" outlined dense :disabled="true" hide-details></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.active') }}</span>
              </div>
              <div class="float-left column-contents-w chk-min-con">
                <v-checkbox v-model="copyFormData.active" :disabled="copyFormData.active === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.beginEnd') }}</span>
              </div>
              <div class="float-left column-contents-w chk-min-con">
                <v-checkbox v-model="copyFormData.beginEnd" :disabled="copyFormData.beginEnd === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.elapse') }}</span>
              </div>
              <div class="float-left column-contents-w chk-min-con">
                <v-checkbox v-model="copyFormData.elapse" :disabled="copyFormData.elapse === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.elapseTerm') }}</span>
              </div>
              <div class="float-left column-contents-w">
                <v-text-field v-model="copyFormData.elapseTerm" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.notEnd') }}</span>
              </div>
              <div class="float-left column-contents-w chk-min-con">
                <v-checkbox v-model="copyFormData.notEnd" :disabled="copyFormData.notEnd === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.monitor.endTime') }}</span>
              </div>
              <div class="float-left column-contents-w">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="currentTime.hh" :items="hhOptions" item-text="text" item-value="value" class="time-select-w"
                  :menu-props="{ offsetY: true }" hide-details outlined dense
                ></v-select>
                <span class="time-text-mg">:</span>
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="currentTime.mm" :items="mmOptions" item-text="text" item-value="value" class="time-select-w"
                  :menu-props="{ offsetY: true }" hide-details outlined dense
                ></v-select>
                <span class="time-text-mg">:</span>
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="currentTime.ss" :items="mmOptions" item-text="text" item-value="value" class="time-select-w"
                  :menu-props="{ offsetY: true }" hide-details outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name-w">
                <span class="d-flex align-center">{{ this.$t('alert.description') }}</span>
              </div>
              <div class="float-left column-contents-w">
                <v-text-field v-model="copyFormData.programDescription" class="w-auto" hide-details outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1" v-if="formData.active">
              <div class="alert-user-wrap-btn-pd">
                <v-btn @click="openAlertUser()" small>{{ this.$t('alert.user.settings') }}</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" :disabled="!btnDisabled" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="close()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
      <AlertUser ref="monitorAlertUserComp" :userFormData="userParams" :dscType="'monitor'" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import AlertUser from './components/AlertUser';
import _ from 'lodash';

export default {
  name: 'MonitorForm',
  components: {
    AlertUser,
  },
  props: {
    formData: Object,
    formMode: String,
    programNames: Array,
  },
  data() {
    return {
      show: false,
      isShow: false,
      loading: false,
      copyFormData: {},
      programType: [
        { value: 'BACKGROUND', text: this.$t('alert.monitor.background') },
        { value: 'NORMAL', text: this.$t('alert.monitor.normal') },
      ],
      hhOptions: this.timeOptions(24),
      mmOptions: this.timeOptions(),
      currentTime: {
        hh: '',
        mm: '',
        ss: '',
        date: '',
      },
      userParams: {},
      valid: true,
      errorMessages: '',
    };
  },
  computed: {
    ...mapState('preference/alert', ['addMonitorsStatus', 'updateMonitorStatus']),
    modeTitle() {
      return this.formMode !== 'new' ? 'Edit Program Monitor' : 'Add New Program Monitor';
    },
    btnDisabled() {
      return !!this.copyFormData.programType && !!this.copyFormData.programName && this.valid;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    show(val) {
      if (val) this.copyPropData();
    },
    copyFormData() {
      this.isShow = true;
    },
    'copyFormData.elapseTerm'(val) {
      const addComma = val
        .toString()
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      this.$nextTick(() => (this.copyFormData.elapseTerm = addComma));
    },
    currentTime: {
      handler(val) {
        this.currentTime.date = `${val.hh}:${val.mm}:${val.ss}`;
        const timeArr = Object.values(_.omit(val, 'date'));
        const timeArrRs = timeArr.some(el => el.length > 0);
        if (timeArrRs) this.initTimeEmptyVal();
      },
      deep: true,
    },
    addMonitorsStatus(val) {
      if (val === 'success') this.sucessOpen();
    },
    updateMonitorStatus(val) {
      if (val === 'success') this.sucessOpen();
    },
  },
  methods: {
    async copyPropData() {
      await this.times(this.formData);
      this.copyFormData = await { ...this.formData };
    },
    openAlertUser() {
      this.userParams = {
        systemId: this.copyFormData.systemId,
        sapDataCode: 'PGM_MNTR',
        alertCode: this.copyFormData.programName,
        programName: this.copyFormData.programName,
        sapDataCodeText: 'Program Monitor',
      };
      this.$refs.monitorAlertUserComp.$data.userShow = true;
    },
    initVal() {
      this.isShow = false;
      this.currentTime = {
        hh: '',
        mm: '',
        ss: '',
        date: '',
      };
      this.errorMessages = '';
      this.valid = true;
    },
    close() {
      this.show = false;
      this.initVal();
    },
    initTimeEmptyVal() {
      for (let prop in this.currentTime) {
        if (!this.currentTime[prop]) this.currentTime[prop] = '00';
      }
    },
    validPgName() {
      let nidx = this.programNames.findIndex(el => el === this.copyFormData.programName);
      this.errorMessages = nidx === -1 ? '' : this.$t('validation.registered');
      this.valid = nidx === -1 ? true : false;
    },
    validPgNameRule() {
      this.formMode === 'new' ? this.validPgName() : this.formData.programName !== this.copyFormData.programName ? this.validPgName() : false;
    },
    save() {
      const params = {
        systemId: this.copyFormData.systemId,
        programName: this.copyFormData.programName,
        programType: this.copyFormData.programType,
        beginEnd: this.copyFormData.beginEnd,
        notEnd: this.copyFormData.notEnd,
        elapse: this.copyFormData.elapse,
        active: this.copyFormData.active,
        endTime: this.currentTime.date === '::' ? '' : this.currentTime.date,
        elapseTerm: Number(this.copyFormData.elapseTerm.replace(/,/g, '')),
        batchDays: this.copyFormData.batchDays,
        programDescription: this.copyFormData.programDescription,
      };
      let actionName = this.formMode === 'new' ? 'preference/alert/addMonitors' : 'preference/alert/updateMonitors';
      this.$store.dispatch(actionName, params);
    },
    timeOptions(max = 60) {
      let opts = [];
      for (let i = 0; i < max; i++) {
        opts.push({
          value: i < 10 ? `0${i}` : i.toString(),
          text: i < 10 ? `0${i}` : i.toString(),
        });
      }
      return opts;
    },
    times(value) {
      if (!value.endTime) return false;
      value = format(new Date(value.endTime), 'HH:mm:ss');
      let valArr = value.split(':');
      this.currentTime = {
        hh: valArr[0],
        mm: valArr[1],
        ss: valArr[2],
        date: `${valArr[0]}:${valArr[1]}:${valArr[2]}`,
      };
    },
    async sucessOpen() {
      await this.close();
      this.$dialog.info(this.$t('common.successful'));
    },
  },
};
</script>
